import { authFetch } from './api';

// The partner program endpoints (backend src/controller/referral.py). Failures are reported by the page
// itself (index.js lists /referral/ as locally handled), so every error becomes one of these message keys.
const KNOWN_ERRORS = ['invalid_target', 'too_many_links', 'invalid_holder', 'invalid_iban', 'invalid_email',
  'payout_storage_unavailable', 'terms_outdated', 'partner_blocked'];

const BONUS_ERRORS = ['invalid_profile_url', 'invalid_post_url', 'confirmations_missing', 'invalid_agent', 'profile_used',
  'already_claimed', 'no_more_resubmits'];

export function referralApi(path, options) {
  return call('referral', path, options);
}

// The LinkedIn bonus (backend src/controller/bonus.py); errors shown in its modal (/bonus/ is locally handled too).
export function bonusApi(path, options) {
  return call('bonus', path, options);
}

export function bonusErrorKey(error) {
  return BONUS_ERRORS.includes(error?.message) ? `bonus_error_${error.message}` : referralErrorKey(error);
}

async function call(prefix, path, { method = 'GET', body } = {}) {
  const base = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
  const response = await authFetch(`${base}/${prefix}/${path}`, body === undefined ? { method } : { method, body: JSON.stringify(body) });
  if (!response) throw new Error('session'); // authFetch already sends the user to the login
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(typeof data?.detail === 'string' ? data.detail : 'request_failed');
    error.status = response.status;
    throw error;
  }
  return data;
}

export function referralErrorKey(error) {
  return `partner_error_${KNOWN_ERRORS.includes(error?.message) ? error.message : 'generic'}`;
}
